module.exports = __webpack_public_path__ + "media/public/img/landing_page/headout-icon-f56aec31d5afb3ecd85be80c7ca9a116.png";